import { render, staticRenderFns } from "./ConfirmAgreements.vue?vue&type=template&id=5553c48c&scoped=true&"
import script from "./ConfirmAgreements.vue?vue&type=script&lang=js&"
export * from "./ConfirmAgreements.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmAgreements.vue?vue&type=style&index=0&id=5553c48c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5553c48c",
  null
  
)

export default component.exports